import { render, staticRenderFns } from "./Sftp.vue?vue&type=template&id=8a9db404&scoped=true"
import script from "./Sftp.vue?vue&type=script&lang=js"
export * from "./Sftp.vue?vue&type=script&lang=js"
import style0 from "./Sftp.vue?vue&type=style&index=0&id=8a9db404&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9db404",
  null
  
)

export default component.exports